const env = {
  ENVIRONMENT: import.meta.env.REACT_APP_ENVIRONMENT ?? '',
  COPYRIGHT: import.meta.env.REACT_APP_COPYRIGHT ?? '',
  HOST: import.meta.env.REACT_APP_HOST ?? '',
  REPORT_HOST: import.meta.env.REACT_APP_REPORT_HOST ?? '',
  PAY_HOST: import.meta.env.REACT_APP_PAY_HOST ?? '',
  STATIC_HOST: import.meta.env.REACT_APP_STATIC_HOST ?? '',
  GO_HOST: import.meta.env.REACT_APP_GO_HOST ?? '',
  PUBLIC_HOST: import.meta.env.REACT_APP_PUBLIC_HOST ?? '',
  BUILDER_HOST: import.meta.env.REACT_APP_BUILDER_HOST ?? '',
  PIXEL_HOST: import.meta.env.REACT_APP_PIXEL_HOST ?? '',
  SITE_HOST: import.meta.env.REACT_APP_SITE_HOST ?? '',
  COOKIE_HOST: import.meta.env.REACT_APP_COOKIE_HOST ?? '',
  TICKET_BASE_URL: import.meta.env.REACT_APP_TICKET_BASE_URL ?? '',
  SUPPORT_EMAIL: import.meta.env.REACT_APP_SUPPORT_EMAIL ?? '',
  SUPPORT_PHONE_DISPLAY: import.meta.env.REACT_APP_SUPPORT_PHONE_DISPLAY ?? '',
  SUPPORT_WHATSAPP_URL: import.meta.env.REACT_APP_SUPPORT_WHATSAPP_URL ?? '',
  SHOW_ASAAS_SEAL: import.meta.env.REACT_APP_SHOW_ASAAS_SEAL === 'true',
} as const

export default env
